import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';

import { authSlice } from './slices/authSlice';
import { betSlice } from './slices/betSlice';
import { apiSlice } from './api/apiSlice';
import { accountSlice } from './slices/accountSlice';
import { currentBetCountSlice } from './slices/currentBetCountSlice';
import { parlaySlice } from './slices/parlaySlice';
import { stakeSlice } from './slices/stakeSlice';
import { fancyProfitLossSlice } from './slices/fancyProfitLossSlice';

export const store = configureStore({
  reducer: {
    auth: authSlice.reducer,
    account: accountSlice.reducer,
    bet: betSlice.reducer,
    currentBetCount: currentBetCountSlice.reducer,
    parlay: parlaySlice.reducer,
    api: apiSlice.reducer,
    stakes: stakeSlice.reducer,
    fancyProfitLoss: fancyProfitLossSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }).concat(apiSlice.middleware),
  devTools: import.meta.env.DEV,
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
